import React, { FC } from 'react';
import {
  Box,
  Divider,
  Flex,
  DeprecatedIcon,
  Pane,
  Tooltip,
  Typography,
} from '@fullstory/components';
import { APIPill } from '../APIPill';
import { intl } from '@fullstory/intl';
import { FormattedMessage } from 'react-intl';

type APIDefinitionType = 'page' | 'customEvent';

interface APIDefinitionProps {
  name: string;
  label: string;
  objectType: APIDefinitionType;
  tooltipContent: React.ReactNode;
}

const apiDefinitionMessages: { [key in APIDefinitionType]: { createdByApi: string } } = {
  page: {
    createdByApi: intl.formatMessage({
      defaultMessage: 'This page was created with the Fullstory API',
      id: 'QcbQHd',
    }),
  },
  customEvent: {
    createdByApi: intl.formatMessage({
      defaultMessage: 'This custom event was created with the Fullstory API',
      id: '9fj5xR',
    }),
  },
};

export const APIDefinition: FC<APIDefinitionProps> = ({
  name,
  label,
  objectType,
  tooltipContent,
}) => (
  <>
    <Box marginBottom={8}>
      <Flex justifyContent="flex-start">
        <Typography variant="body2">
          <FormattedMessage defaultMessage="Definition" id="KbSPMS" />
        </Typography>
        <Box marginLeft={8} testId="info-icon">
          <Tooltip
            tooltipContent={tooltipContent}
            placement="right-start"
            variant="light"
            maxWidth={425}
          >
            <DeprecatedIcon name="information-secondary" color="neutrals-n10" size={16} />
          </Tooltip>
        </Box>
      </Flex>
    </Box>
    <Pane borderRadius={4} border="standard" marginBottom={24}>
      <Box margin={[12, 24]}>
        <Flex justifyContent="flex-start">
          <Box marginRight={8}>
            <APIPill tooltipContent={tooltipContent} />
          </Box>
          <Typography variant="body2">{apiDefinitionMessages[objectType].createdByApi}</Typography>
        </Flex>
      </Box>
      <Divider />
      <Box margin={24}>
        <Flex justifyContent="flex-start">
          <Box marginRight={16}>
            <Typography variant="body3" color="neutrals-n7">
              {label}
            </Typography>
          </Box>
          <Typography variant="body3">{name}</Typography>
        </Flex>
      </Box>
    </Pane>
  </>
);
